import employeeApi from "apis/employee";
import { WebApiRequest, WebApiReduxRequest, HTTP_GET, HTTP_POST, HTTP_PUT } from "tools/webservice";
import {
  REQUEST_ALL_BUS_OPS_DIRECTORS,
  RECEIVE_ALL_BUS_OPS_DIRECTORS,
  ERROR_ALL_BUS_OPS_DIRECTORS,
  REQUEST_FIELD_DEVELOPMENT_MANAGERS,
  RECEIVE_FIELD_DEVELOPMENT_MANAGERS,
  ERROR_FIELD_DEVELOPMENT_MANAGERS,
  REQUEST_LENDER_LOGISTICS_MANAGERS,
  RECEIVE_LENDER_LOGISTICS_MANAGERS,
  ERROR_LENDER_LOGISTICS_MANAGERS,
  REQUEST_ALL_BUS_OPS_MANAGERS,
  RECEIVE_ALL_BUS_OPS_MANAGERS,
  ERROR_ALL_BUS_OPS_MANAGERS,
  REQUEST_OPERATIONS_MANAGERS,
  RECEIVE_OPERATIONS_MANAGERS,
  ERROR_OPERATIONS_MANAGERS,
  REQUEST_SCHEDULING_USERS,
  RECEIVE_SCHEDULING_USERS,
  ERROR_SCHEDULING_USERS,
  REQUEST_CUSTOMER_EXPERIENCE_MANAGERS,
  RECEIVE_CUSTOMER_EXPERIENCE_MANAGERS,
  ERROR_CUSTOMER_EXPERIENCE_MANAGERS,
  RECEIVE_CUSTOMER_EXPERIENCE_DIRECTORS,
  ERROR_CUSTOMER_EXPERIENCE_DIRECTORS,
  REQUEST_CUSTOMER_EXPERIENCE_DIRECTORS,
} from "typeConstants";
import {
  BUSOP_DIRECTOR,
  BUSOP_MANAGER,
  CUSTOMER_EXPERIENCE_DIRECTOR,
  CUSTOMER_EXPERIENCE_MANAGER,
  FIELD_DEVELOPMENT_MANAGER,
  LENDER_LOGISTICS_MANAGER,
  FIELD_OPERATIONS_MANAGER,
  CUSTOMER_EXPERIENCE_REP
} from "typeConstants/employeeRoles";

export const getOperationsManagementEmployees = (searchTerm, includeInactive, successCallback, mountedRef, errorCallback) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeApi.getOperationsManagementEmployees(searchTerm, includeInactive),
      successCallback,
      mountedRef,
      errorCallback,
    }
  );
};

export const getEmployeesByRoles = (employeeRolesArray, successCallback, mountedRef) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeApi.getEmployeesByRoles(employeeRolesArray),
      successCallback,
      mountedRef
    });
};
export const getEmployeeDetails = (internetUserId, successCallback, mountedRef) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeApi.getEmployeeDetails(internetUserId),
      successCallback,
      mountedRef
    });
};
export const getEmployeeDetailsByEmployeeId = (employeeId, successCallback, mountedRef, errorCallback) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeApi.getEmployeeDetailsByEmployeeId(employeeId),
      successCallback,
      mountedRef,
      errorCallback
    });
};
export const updateEmployeeDetails = (internetUserId, payload, successCallback, mountedRef) => {
  return WebApiRequest(
    {
      method: HTTP_PUT,
      endpoint: employeeApi.updateEmployeeDetails(internetUserId),
      payload,
      successCallback,
      mountedRef
    });
};
export const updateEmployeeDetailsByEmployeeId = (employeeId, payload, successCallback, mountedRef, errorCallback) => {
  return WebApiRequest(
    {
      method: HTTP_PUT,
      endpoint: employeeApi.updateEmployeeDetailsByEmployeeId(employeeId),
      payload,
      successCallback,
      mountedRef,
      errorCallback
    });
};
export const getEmployeeNotes = (internetUserId, successCallback, mountedRef) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeApi.getEmployeeNotes(internetUserId),
      successCallback,
      mountedRef
    });
};
export const addEmployeeNote = (payload, internetUserId, successCallback, mountedRef) => {
  return WebApiRequest(
    {
      method: HTTP_POST,
      endpoint: employeeApi.addEmployeeNote(internetUserId),
      payload,
      successCallback,
      mountedRef
    });
};
export const getAllBusOpsDirectorsRedux = () => {
  return WebApiReduxRequest(
    REQUEST_ALL_BUS_OPS_DIRECTORS,
    RECEIVE_ALL_BUS_OPS_DIRECTORS,
    ERROR_ALL_BUS_OPS_DIRECTORS,
    HTTP_GET,
    employeeApi.getEmployeesByRoles([BUSOP_DIRECTOR]));
};
export const getAllBusOpsManagersRedux = () => {
  return WebApiReduxRequest(
    REQUEST_ALL_BUS_OPS_MANAGERS,
    RECEIVE_ALL_BUS_OPS_MANAGERS,
    ERROR_ALL_BUS_OPS_MANAGERS,
    HTTP_GET,
    employeeApi.getEmployeesByRoles([BUSOP_MANAGER]));
};
export const searchEmployees = (searchTerm, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: employeeApi.searchEmployees(searchTerm),
  successCallback,
  mountedRef,
});
export const getAllFieldDevelopmentManagersRedux = () => {
  return WebApiReduxRequest(
    REQUEST_FIELD_DEVELOPMENT_MANAGERS,
    RECEIVE_FIELD_DEVELOPMENT_MANAGERS,
    ERROR_FIELD_DEVELOPMENT_MANAGERS,
    HTTP_GET,
    employeeApi.getEmployeesByRoles([FIELD_DEVELOPMENT_MANAGER]));
};
export const getAllLenderLogisticsManagers = () => WebApiReduxRequest(
  REQUEST_LENDER_LOGISTICS_MANAGERS,
  RECEIVE_LENDER_LOGISTICS_MANAGERS,
  ERROR_LENDER_LOGISTICS_MANAGERS,
  HTTP_GET,
  employeeApi.getEmployeesByRoles([LENDER_LOGISTICS_MANAGER])
);

export const getAllFieldOperationsManagers = () => WebApiReduxRequest(
  REQUEST_OPERATIONS_MANAGERS,
  RECEIVE_OPERATIONS_MANAGERS,
  ERROR_OPERATIONS_MANAGERS,
  HTTP_GET,
  employeeApi.getEmployeesByRoles([FIELD_OPERATIONS_MANAGER]));

export const searchFieldSchedulingUsers = (searchTerm) => WebApiReduxRequest(
  REQUEST_SCHEDULING_USERS,
  RECEIVE_SCHEDULING_USERS,
  ERROR_SCHEDULING_USERS,
  HTTP_GET,
  employeeApi.searchEmployees(searchTerm, [
    CUSTOMER_EXPERIENCE_REP,
    CUSTOMER_EXPERIENCE_MANAGER,
    CUSTOMER_EXPERIENCE_DIRECTOR,]),
);

export const getAllCustomerExperienceManagers = () => WebApiReduxRequest(
  REQUEST_CUSTOMER_EXPERIENCE_MANAGERS,
  RECEIVE_CUSTOMER_EXPERIENCE_MANAGERS,
  ERROR_CUSTOMER_EXPERIENCE_MANAGERS,
  HTTP_GET,
  employeeApi.getEmployeesByRoles([CUSTOMER_EXPERIENCE_MANAGER])
);

export const getAllCustomerExperienceDirectors = () => WebApiReduxRequest(
  REQUEST_CUSTOMER_EXPERIENCE_DIRECTORS,
  RECEIVE_CUSTOMER_EXPERIENCE_DIRECTORS,
  ERROR_CUSTOMER_EXPERIENCE_DIRECTORS,
  HTTP_GET,
  employeeApi.getEmployeesByRoles([CUSTOMER_EXPERIENCE_DIRECTOR])
);